import {Api} from "../api/api";
import {formattingDate, getCurrentUser} from "../utils/common";
import {ActivityType} from "../utils/consts";

// TODO: При переключении страниц и обновлении таймера менять состояние кнопок на самих страницах

const TimerStatus = {
  PAUSE: `PAUSE`,
  PLAY: `PLAY`,
  SEND: `SEND`,
};

const TIMER_HIDDEN_CLASS = `timer__wrapper--hide`;

const showModalsEmails = [`d.bobokalonova@d-idei.ru`, `spiridonov@d-idei.ru`, `mail@d-idei.ru`];

const ActiveClass = {
  favorite: `favourites__timer--active`,
  task: `one-task__timer--started`,
};

const InactiveClass = {
  activeTime: `time__active--hide`,
  inactiveTime: `time__icon--hide`,
};

const FaviconRootPath = {
  PAUSE: `/img/favicon/`,
  PLAY: `/img/favicon/timer/`,
};

export class Timer {
  _eventEmitter = window.taskEmitter;
  private _taskID: string | null;

  private _timerContainerElement: HTMLElement;
  private readonly _timerElement: HTMLElement | null;
  private _timerTaskNamesElement: HTMLElement | null;
  private readonly _timerTaskNameElement: HTMLAnchorElement | null;
  private _timerTimeWrapperElement: HTMLElement | null;
  private readonly _timerProjectNameElement: HTMLAnchorElement | null;
  private _timerPreloaderElement: HTMLElement | null;
  private _starterTimerElements: NodeListOf<HTMLElement>;
  private readonly _hoursElement: HTMLElement | null;
  private readonly _minutesElement: HTMLElement | null;
  private readonly _secondsElement: HTMLElement | null;
  private readonly _faviconLinkApple: HTMLLinkElement | null;
  private readonly _faviconLinkManifest: HTMLLinkElement | null;
  private readonly _faviconLinkSvg: HTMLLinkElement | null;
  private readonly _faviconLinkIco: HTMLLinkElement | null;
  private readonly _activeTimeIcon: HTMLElement | null;
  private readonly _inactiveTimeIcon: HTMLElement | null;
  private _timerOnModal: HTMLElement | null;
  private _timerOnModalCloseButtons: NodeListOf<HTMLElement>;
  private _timerApi: Api;
  private _hours: number;
  private _minutes: number;
  private _seconds: number;
  private readonly _isTimerHidden: boolean;
  private _timerStatus: string;
  private _starterButtonsElements: HTMLElement[];
  private _interval: number;

  constructor(timerContainer: HTMLElement) {
    this._timerContainerElement = timerContainer;

    this._timerElement = this._timerContainerElement.querySelector(`.js-timer`);
    this._timerTaskNamesElement = this._timerContainerElement.querySelector(`.js-timer-names`);
    this._timerTaskNameElement = this._timerTaskNamesElement!.querySelector(`.js-timer-task-name`);
    this._timerProjectNameElement = this._timerTaskNamesElement!.querySelector(`.js-timer-project-name`);
    this._timerTimeWrapperElement = this._timerContainerElement.querySelector(`.js-timer-time`);
    this._timerPreloaderElement = this._timerContainerElement.querySelector(`.js-timer-preloader`);
    this._starterTimerElements = document.querySelectorAll(`.js-timer-start`);
    this._hoursElement = this._timerTimeWrapperElement!.querySelector(`.js-timer-hours`);
    this._minutesElement = this._timerTimeWrapperElement!.querySelector(`.js-timer-minutes`);
    this._secondsElement = this._timerTimeWrapperElement!.querySelector(`.js-timer-seconds`);
    this._faviconLinkApple = document.head.querySelector(`.js-favicon-apple`);
    this._faviconLinkManifest = document.head.querySelector(`.js-favicon-manifest`);
    this._faviconLinkSvg = document.head.querySelector(`.js-favicon-svg`);
    this._faviconLinkIco = document.head.querySelector(`.js-favicon-ico`);

    this._activeTimeIcon = document.querySelector(`.js-time-icon-active`);
    this._inactiveTimeIcon = document.querySelector(`.js-time-icon-inactive`);

    this._timerOnModal = document.querySelector(`.js-timer-on-modal`);
    this._timerOnModalCloseButtons = document.querySelectorAll(`.js-close-timer-on`);

    this._timerApi = new Api();

    this._hours = +this._hoursElement!.textContent!;
    this._minutes = +this._minutesElement!.textContent!;
    this._seconds = +this._secondsElement!.textContent!;

    this._isTimerHidden = this._timerContainerElement.classList.contains(TIMER_HIDDEN_CLASS);

    this._starterTimerElementClickHandler = this._starterTimerElementClickHandler.bind(this);
    this._documentVisibilityChangeHandler = this._documentVisibilityChangeHandler.bind(this);
    this.updateTimer = this.updateTimer.bind(this);
  }

  init() {
    this._setInitialTimerStatus();
    this._setTaskIdFromElement(this._timerElement);
    this._getStarterButtonsElement();

    if (this._timerStatus === TimerStatus.PLAY) {
      this._start();
      this._setStarterButtonsOnTaskPageActivityStatus();
      // this._setIconOnTaskPageActivityStatus();
    }
    // else if (this._timerStatus === TimerStatus.PAUSE && showModalsEmails.includes(getCurrentUser().email)) {
    //   this._setActivityStatusTimerOnModal(ActivityType.SHOW);
    // }

    if (this._starterTimerElements.length) {
      this._starterTimerElements.forEach((starterTimerElement) =>
        starterTimerElement.addEventListener(`click`, this._starterTimerElementClickHandler),
      );
    }

    // if (this._timerOnModalCloseButtons.length) {
    //   this._timerOnModalCloseButtons.forEach((element) => {
    //     element.addEventListener(`click`, () => this._setActivityStatusTimerOnModal(ActivityType.HIDE));
    //   });
    // }

    document.addEventListener("visibilitychange", this._documentVisibilityChangeHandler);
    this._eventEmitter.on(`timer.update`, this.updateTimer);
  }

  async updateTimer() {
    const res = await this._timerApi.viewTimer();

    if (res.code === 200) {
      const {
              answer: {
                timer: {hours, min, sec, task, project, urlTask, urlProject, taskId, isActive},
              },
            } = res;

      this._setTime(hours, min, sec);
      this._setTimerTextContents();

      if (taskId) {
        this._setTaskIdFromServer(taskId);
      }

      if (isActive && this._timerStatus === TimerStatus.PAUSE) {
        this._start();
      }

      if (!isActive && this._timerStatus === TimerStatus.PLAY) {
        this._stop();
      }

      this._setTimerElementActivityStatus();

      if (task && project && urlTask && urlProject) {
        this._setTimerTaskNames(task, project, urlProject, urlTask);
        this._showTaskNamesElement();
      }
    }
  }

  _setActivityStatusTimerOnModal(type: string) {
    switch (type) {
      case ActivityType.SHOW:
        this._timerOnModal?.classList.add(`main__modal--show`);
        break;
      case ActivityType.HIDE:
        this._timerOnModal?.classList.remove(`main__modal--show`);
        break;
    }
  }

  _setActivityStatusPreloader(type: string) {
    switch (type) {
      case ActivityType.SHOW:
        this._timerPreloaderElement?.classList.remove(`timer__preloader--hide`);
        break;
      case ActivityType.HIDE:
        this._timerPreloaderElement?.classList.add(`timer__preloader--hide`);
        break;
    }
  }

  _setActivityStatusTimeWrapper(type: string) {
    switch (type) {
      case ActivityType.SHOW:
        this._timerTimeWrapperElement?.classList.remove(`timer__time--hide`);
        break;
      case ActivityType.HIDE:
        this._timerTimeWrapperElement?.classList.add(`timer__time--hide`);
        break;
    }
  }

  _showTimerElement() {
    this._timerContainerElement.classList.remove(TIMER_HIDDEN_CLASS);
  }

  _getStarterButtonsElement() {
    this._starterButtonsElements = Array.from(this._starterTimerElements)
      .filter(
        (element) =>
          (element.dataset.timerStartType === `task` || element.dataset.timerStartType === `favorite`) &&
          element.dataset.taskId === this._taskID,
      );
  }

  _setStarterButtonsOnTaskPageActivityStatus() {
    if (this._starterButtonsElements.length) {
      this._starterButtonsElements.forEach((element) => this._setTaskStartButtonElementActivityStatus(element));
    }
  }

  _setIconOnTaskPageActivityStatus() {
    if (this._activeTimeIcon && this._inactiveTimeIcon && this._taskID === this._activeTimeIcon.dataset.taskId!) {
      if (this._timerStatus === TimerStatus.PAUSE) {
        this._activeTimeIcon.classList.add(InactiveClass.activeTime);
        this._inactiveTimeIcon.classList.remove(InactiveClass.inactiveTime);
      } else {
        this._activeTimeIcon.classList.remove(InactiveClass.activeTime);
        this._inactiveTimeIcon.classList.add(InactiveClass.inactiveTime);
      }
    }
  }

  _setInitialTimerStatus() {
    if (this._timerElement?.classList.contains(`timer__clock--active`)) {
      this._timerStatus = TimerStatus.PLAY;
    } else {
      this._timerStatus = TimerStatus.PAUSE;
    }
  }

  _setTaskIdFromElement(element: HTMLElement | null) {
    this._taskID = element?.dataset.taskId?.length ? element.dataset.taskId : null;
  }

  _setTaskIdFromServer(taskId: number) {
    this._taskID = taskId.toString();

    this._setTimerElementTaskId();
  }

  _setTimerElementTaskId() {
    if (!this._timerElement) return;

    if (this._taskID && this._taskID.length) {
      this._timerElement.dataset.taskId = this._taskID;
    }
  }

  _start() {
    this._timerStatus = TimerStatus.PLAY;
    this._changeFavicon(TimerStatus.PLAY);

    // @ts-ignore
    this._interval = setInterval(() => {
      this._seconds++;

      if (this._seconds === 60) {
        this._seconds = 0;
        this._minutes++;
      }

      if (this._minutes === 60) {
        this._minutes = 0;
        this._hours++;
      }

      this._setTimerTextContents();
    }, 1000);
  }

  _stop() {
    clearInterval(this._interval);
    this._timerStatus = TimerStatus.PAUSE;
    this._changeFavicon(TimerStatus.PAUSE);
  }

  _setTimerTextContents() {
    if (this._hoursElement) {
      this._hoursElement.textContent = this._hours < 10 ? `0${this._hours}` : this._hours.toString(10);
    }

    if (this._minutesElement) {
      this._minutesElement.textContent = this._minutes < 10 ? `0${this._minutes}` : this._minutes.toString(10);
    }

    if (this._secondsElement) {
      this._secondsElement.textContent = this._seconds < 10 ? `0${this._seconds}` : this._seconds.toString(10);
    }
  }

  _setTimerElementActivityStatus() {
    if (this._timerStatus === TimerStatus.PAUSE) {
      this._timerElement?.classList.remove(`timer__clock--active`);
    } else {
      this._timerElement?.classList.add(`timer__clock--active`);
    }
  }

  // функция переключения фавиконки при активировании таймера
  _changeFavicon(status: string) {
    if (this._faviconLinkApple && this._faviconLinkManifest && this._faviconLinkIco && this._faviconLinkSvg) {
      this._faviconLinkApple.href = `${FaviconRootPath[status]}apple-touch-icon.png`;
      this._faviconLinkManifest.href = `${FaviconRootPath[status]}site.webmanifest`;
      this._faviconLinkIco.href = `${FaviconRootPath[status]}favicon.ico`;
      this._faviconLinkSvg.href = `${FaviconRootPath[status]}favicon.svg`;
    }
  }

  _setTaskStartButtonElementActivityStatus(element: HTMLElement) {
    const activeTimerClass = ActiveClass[element.dataset.timerStartType!];

    if (this._timerStatus === TimerStatus.PAUSE) {
      element.classList.remove(activeTimerClass);
    } else {
      element.classList.add(activeTimerClass);
    }
  }

  _setTime(hours: string, minutes: string, seconds: string) {
    this._hours = +hours;
    this._minutes = +minutes;
    this._seconds = +seconds;
  }

  _removeStarterButtonsOnTaskPageActivityStatus() {
    if (this._starterButtonsElements.length) {
      this._starterButtonsElements.forEach((element) => {
        element.classList.remove(ActiveClass[element.dataset.timerStartType!]);
      });
    }
  }

  _setAllButtonsActivityStatus(target: HTMLElement) {
    this._setTimerElementActivityStatus();

    this._setTaskStartButtonElementActivityStatus(target);
    this._removeStarterButtonsOnTaskPageActivityStatus();
    this._getStarterButtonsElement();
    this._setStarterButtonsOnTaskPageActivityStatus();
    // this._setIconOnTaskPageActivityStatus();
  }

  _showTaskNamesElement() {
    if (this._timerTaskNamesElement?.classList.contains(`timer__info--hidden`)) {
      this._timerTaskNamesElement.classList.remove(`timer__info--hidden`);
    }
  }

  _setTimerTaskNames(taskName: string, projectName: string, projectUrl: string, taskUrl: string | null) {
    if (this._timerTaskNameElement) {
      this._timerTaskNameElement.textContent = taskName;
      this._timerTaskNameElement.href = taskUrl ? taskUrl : location.href;
    }

    if (this._timerProjectNameElement) {
      this._timerProjectNameElement.textContent = projectName;
      this._timerProjectNameElement.href = projectUrl;
    }
  }

  _starterTimerElementClickHandler(evt: Event) {
    evt.preventDefault();

    if (this._timerStatus === TimerStatus.SEND) {
      return;
    }

    const self = evt.currentTarget as HTMLElement;
    const isTaskPageButtonStart = self.dataset.timerStartType === `task`;
    const isFavoriteListButtonStart = self.dataset.timerStartType === `favorite`;
    const taskName = self.dataset.taskName!;
    const taskUrl = self.dataset.taskUrl ? self.dataset.taskUrl : null;
    const projectName = self.dataset.projectName!;
    const projectUrl = self.dataset.projectUrl!;

    if (this._taskID && this._taskID !== self.dataset.taskId && this._timerStatus === TimerStatus.PLAY) {
      this._timerStatus = TimerStatus.SEND;
      this._setActivityStatusPreloader(ActivityType.SHOW);
      this._setActivityStatusTimeWrapper(ActivityType.HIDE);

      this._setTaskIdFromElement(self);
      this._setTimerElementTaskId();

      this._timerApi.startTimer(this._taskID)
        .then(() => {
          this._timerStatus = TimerStatus.PLAY;

          this._setActivityStatusPreloader(ActivityType.HIDE);
          this._setActivityStatusTimeWrapper(ActivityType.SHOW);

          if (isTaskPageButtonStart || isFavoriteListButtonStart) {
            this._showTaskNamesElement();
            this._setTimerTaskNames(taskName, projectName, projectUrl, taskUrl);
          }

          this._setAllButtonsActivityStatus(self);
        });
      return;
    }

    this._setTaskIdFromElement(self);
    this._setTimerElementTaskId();

    if (this._timerStatus === TimerStatus.PAUSE) {
      if (this._taskID) {
        this._timerStatus = TimerStatus.SEND;
        this._setActivityStatusPreloader(ActivityType.SHOW);
        this._setActivityStatusTimeWrapper(ActivityType.HIDE);

        this._timerApi.startTimer(this._taskID)
          .then((data) => {
            this._start();
            this._setActivityStatusPreloader(ActivityType.HIDE);
            this._setActivityStatusTimeWrapper(ActivityType.SHOW);

            if (isTaskPageButtonStart || isFavoriteListButtonStart) {
              this._showTaskNamesElement();
              this._setTimerTaskNames(taskName, projectName, projectUrl, taskUrl);
            }

            if (this._isTimerHidden) {
              this._showTimerElement();
            }

            this._setAllButtonsActivityStatus(self);
          });
      }
    } else {
      this._timerStatus = TimerStatus.SEND;
      this._setActivityStatusPreloader(ActivityType.SHOW);
      this._setActivityStatusTimeWrapper(ActivityType.HIDE);

      this._timerApi.stopTimer()
        .then((data) => {
          if (data.code === 200) {
            this._setActivityStatusPreloader(ActivityType.HIDE);
            this._setActivityStatusTimeWrapper(ActivityType.SHOW);

            const {hours, min, sec} = data.answer.timer;
            const {time, id, timerId, totalTime} = data.answer.task;

            this._stop();
            this._setTime(hours, min, sec);
            this._setTimerTextContents();
            this._setAllButtonsActivityStatus(self);

            if (+(document.querySelector(`[data-tasks-list-type="one-task"]`) as HTMLElement)?.dataset.id! === id) {
              const user = getCurrentUser();
              this._eventEmitter.emit(`timerModal.addItem`, {
                user,
                date: formattingDate(new Date(), {isISO: true})
                  .split("T")[0],
                minutes: time.min,
                hours: time.hours,
                seconds: time.sec,
                taskId: id,
                timerId,
                totalTime,
              });
            }
          }
        });
    }
  }

  async _documentVisibilityChangeHandler() {
    if (document.visibilityState === `visible`) {
      await this.updateTimer();

      // if (this._timerStatus === TimerStatus.PAUSE && showModalsEmails.includes(getCurrentUser().email)) {
      //   this._setActivityStatusTimerOnModal(ActivityType.SHOW);
      // }
    }
  }
}
